import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as queryString from 'query-string';
import PropTypes from 'prop-types';

import MatchingProfiles from './MatchingProfiles';
// import ActivateSelectedProfile from '../../../components/GetRated/ActivateSelectedProfile';
import presetClaimedUser from '../../../components/hocs/presetClaimedUser';
import SplashV3 from '../../../components/Splash/splashV3';
import ProfileSearchForm from './ProfileSearchForm';

import { fetchMatchingProfiles } from '../../../actions/get-rated-actions';
import { claimPlayerV2, createPlayerV2 } from '../../../actions/onboarding-actions';
import { isPlayerRated } from '../../../utils/members';

import styles from '../nuoV2.scss';

const ClaimProfile = (props) => {
    const parsed = queryString.parse(props.location.search);

    const onboarding = useSelector(({ onboarding }) => onboarding);
    const auth = useSelector(({ auth }) => auth);
    const matchedProfiles = useSelector(({ matchedProfiles }) => matchedProfiles);

    const steps = {
        start: {
            title: `${auth?.user?.isRegisteredWithNcsa ? auth?.user?.isNcsaDuplicateRegistration
                ? 'Your NCSA profile already exists! Now' : 'Registered!' : ''} Claim your results`,
            showSearchButton: true,
        },
        search: {
            title: 'Search for a profile.',
            showSearchForm: true,
        },
        results: {
            title: 'Search results',
            showSearchButton: true,
        },
    };

    const [step, setStep] = useState(steps.start);
    const [submitting, setSubmitting] = useState();
    const [manualSearch, setManualSearch] = useState(false);
    const [splashLoading, setSplashLoading] = useState(false);

    const dispatch = useDispatch();

    const userIsPowered = (auth.user?.isPowered) || false;

    useEffect(() => {
        if (matchedProfiles.isLoaded) {
            setSplashLoading(false);
        }
    }, [matchedProfiles]);

    useEffect(() => {
        if (!onboarding.playerId && auth.user) {
            dispatch(fetchMatchingProfiles(auth.user.firstName, auth.user.lastName));
        }
        if (!matchedProfiles.isLoaded) {
            setSplashLoading(true);
        }
    }, []);

    const handleGetRatedSubmit = () => {
        setSubmitting(true);
        let payload;
        if (parsed.id && parsed.token) {
            payload = {
                memberId: auth.user.id,
                inviteToken: parsed.token,
                inviteId: parsed.id,
            };
        } else {
            payload = { memberId: auth.user.id };
        }
        dispatch(createPlayerV2(payload));
    };

    const handleProfileSelect = (profileData) => {
        setSubmitting(true);
        let payload;
        if (parsed.token && parsed.id) {
            payload = {
                selectedPlayerId: profileData.id,
                memberId: auth.user.id,
                inviteToken: parsed.token,
                inviteId: parsed.id,
            };
        } else {
            payload = {
                selectedPlayerId: profileData.id,
                memberId: auth.user.id,
            };
        }
        dispatch(claimPlayerV2(payload, isPlayerRated(profileData)));
    };

    const handleSearchClick = () => {
        setStep(steps.search);
        setManualSearch(true);
    };

    const handleSearchSubmit = () => {
        setStep(steps.results);
    };

    if (splashLoading) {
        return <SplashV3 />;
    }

    return (
        (matchedProfiles.isLoaded || manualSearch) && (
            <div className={styles.pageContent}>
                <div className={styles.title} data-testid="nuo-v2.claim-profile.title">
                    {step.title}
                </div>
                {step.description && (
                    <div className={styles.description} data-testid="nuo-v2.claim-profile.description">
                        {step.description}
                    </div>
                )}
                {step.showSearchForm ? (
                    <ProfileSearchForm
                        firstName={auth.user.firstName}
                        lastName={auth.user.lastName}
                        onSearchSubmit={handleSearchSubmit}
                        fetchMatchingProfiles={(firstName, lastName) => dispatch(fetchMatchingProfiles(firstName, lastName))}
                    />
                ) : (
                    <>
                        {/* {onboarding.playerId ? (
                            <>
                                {(profiles?.length > 0) && (
                                    <ActivateSelectedProfile // TODO: will we need this in the new NUO flow?
                                        profile={profiles[0]}
                                        userIsPowered={userIsPowered}
                                        submitting={submitting}
                                        onContinue={handleGetRatedSubmit}
                                        onProfileSelect={handleProfileSelect}
                                    />
                                )}
                            </>
                        ) : ( */}
                        <MatchingProfiles
                            matchedProfiles={matchedProfiles}
                            fetchMatchingProfiles={(firstName, lastName) => dispatch(fetchMatchingProfiles(firstName, lastName))}
                            onContinue={handleGetRatedSubmit}
                            onProfileSelect={handleProfileSelect}
                            userIsPowered={userIsPowered}
                            firstName={auth.user?.firstName}
                            lastName={auth.user?.lastName}
                            forceMobileUi={props.forceMobileUi}
                            inPopUp={false}
                            submitting={submitting}
                            manualSearch={manualSearch}
                        />
                    </>
                )}
                <div>
                    {step.showSearchButton && (
                        <button
                            type="button"
                            className={`btn btn-default btn-block text-uppercase`}
                            onClick={handleSearchClick}
                            data-testid="nuo-v2.claim-profile.search-btn"
                        >
                            Search
                        </button>
                    )}
                    <div className={`div div-text mt24 mb24 fs12`}><span style={{ background: 'white' }}>OR</span></div>
                    <button
                        type="button"
                        className={`btn btn-primary btn-block text-uppercase`}
                        onClick={handleGetRatedSubmit}
                        disabled={submitting}
                        data-testid="nuo-v2.claim-profile.continue-btn"
                    >
                        Continue
                    </button>
                </div>
            </div>
        )
    );
};

ClaimProfile.propTypes = {
    forceMobileUi: PropTypes.bool,
};

export default presetClaimedUser(ClaimProfile);
